export function filterText(input, option) {
	if (option.value && typeof option.value === 'string') {
		return searchStr(option.value).includes(searchStr(input))
	}

	if (option.label && typeof option.label === 'string') {
		if (typeof option.label !== 'string') return false

		return searchStr(option.label).includes(searchStr(input))
	}

	return false
}

const searchStr = (str) => {
	return str
		? str
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.toLowerCase()
		: str
}
